import Vue from 'vue'
import VueI18n from 'vue-i18n'

// Element UI 语言包
import elementZH from 'element-ui/lib/locale/lang/zh-CN'
import elementEN from 'element-ui/lib/locale/lang/en'
import elementTW from 'element-ui/lib/locale/lang/zh-TW'

Vue.use(VueI18n)

// 你的应用语言文件
import zhCN from './locales/zh-CN.json'
import enUS from './locales/en-US.json'
import zhTW from './locales/zh-TW.json'

// 合并 Element UI 和你的翻译
const messages = {
  'zh-CN': {
    ...zhCN,
    ...elementZH
  },
  'en-US': {
    ...enUS,
    ...elementEN
  },
  'ja-JP': {
    ...zhTW,
    ...elementTW
  }
}

const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'zh-CN',
  fallbackLocale: 'zh-CN',
  messages,
  silentTranslationWarn: true
})

export default i18n